import { usePlayerStore } from '../store/playerStore';

export function usePlayerActorScene(actorId?: string) {
  const store = usePlayerStore();
  const resolvedActorId = actorId ?? store.state.activeActorId;

  if (!resolvedActorId) {
    return null;
  }

  void store.state.actorSceneVersionByActorId[resolvedActorId];

  return store.getActorScene(resolvedActorId);
}
